import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import Actions from './actions';
import { apiUtil } from '../../util';
import { buildError } from "../../util/buildError";
import { errorDuck } from '../error';
import { OrderValidationResponse } from './mockResponses';
import * as UTIL from '../../util';
import RewardsActions from '../rewards/actions';
var Creators = Actions.Creators;
var setReceiptCodeOperation = Creators.setReceiptCode;
var receiveCheckDetailOperation = Creators.receiveCheckDetail;
var receiveOriginalCheckDetail = Creators.receiveOriginalCheckDetail;
var receiveLocationOperation = Creators.receiveLocation;
var payOrderSuccessOperation = Creators.payOrderSuccess;
var setIsLoadingOperation = Creators.setIsLoading;
var setLocationIsLoadingOperation = Creators.setLocationIsLoading;
var setPayOrderPayloadOperation = Creators.setPayOrderPayload;
var setGratuityOpearation = Creators.setGratuity;
var setPaymentMethodOperation = Creators.setPaymentMethod;
var clearOrderOpearation = Creators.clearOrder;
var errorOperations = errorDuck.operations;
var receiveError = errorOperations.receiveError;
var resetRewardsRedemptionAction = RewardsActions.Creators.resetRewardsRedemptionAction;
var resetCheck = Creators.resetCheck;
var useMock = false;
var mockCheck = {
  "OrderCode": "x3efd",
  "Store": "CB0079",
  "NetAmountWithNoTax": 3.990,
  "OrderLines": [{
    "Amount": 3.990,
    "Description": "Biscuit Beignet (6) BarrelBites",
    "Quantity": 1.0
  }],
  "Success": true,
  "Tax": 0.39,
  "PreCheck": "              Cracker Barrel\r\n               Store #CB0079\r\n                     Crossville TN          \r\n\r\nDine-In                    \r\n                           \r\n-------------------------------------------------------\r\n  Table Number: 155   Terminal: CB007911   Guest: 1    \r\n                  3/26/2022    11:24 AM\r\n-------------------------------------------------------\r\n  Server......: 1963905                       TIFFANY M\r\n  Cashier.....: 1963905                                \r\n  Customer No.:                         \r\n  Cust. Name..:                                      \r\n               <B: OT-00001117935>\r\n                                                       \r\n    ITEM NAME                 QTY     PRICE       TOTAL\r\n-------------------------------------------------------\r\n    RP00572    \r\n    Biscuit Beignet (6) Ba      1       3.99       3.99     \r              \r\n     Restaurant\r\r\n            3.99\r\n                                                       \r\n   --------------------------------------------------\r\n    Subtotal                                     $ 3.99\r\n    Total tax                                    $ 0.39\r\n    Tip                                                \r\n    Total                                        $ 4.38\r\n                =======================\r\n                 Gratuity Not Included\r\n\r\n                      Thank You\r\n                   Please Come Back\r\n                 www.CrackerBarrel.com\r\n                   Please Pay Cashier\r\n\r\n                          OR\r\n\r\n     Pay your bill using the\r\n   Cracker Barrel Mobile App\r\n       Receipt Code: X3EFD  \r\n\r\n                        155 \r\n\r\n                                                       \r\n<B: >                                                   \r\n",
  "TotalToPay": 4.380
};
var mockRecipt = JSON.parse("{\"OrderCode\":\"1TDJA\",\"Store\":\"CB0155\",\"NetAmountWithNoTax\":19.18,\"OrderLines\":[{\"Amount\":10.99,\"Description\":\"Sunrise Sampler\",\"Quantity\":1},{\"Amount\":8.19,\"Description\":\"Country Morning Brkfst\",\"Quantity\":1}],\"Success\":true,\"Tax\":1.87,\"Gratuity\":0,\"GrossAmount\":21.05,\"OrderReceipt\":\"               *****  How'd We Do?  *****\\r\\n             At Cracker Barrel, our mission\\r\\n               of pleasing people guides\\r\\n                   everything we do.\\r\\n\\r\\n               We appreciate your visit\\r\\n               and we'd love to know how\\r\\n              we can make it even better!\\r\\n\\r\\n               We welcome your feedback\\r\\n               about your visit today.\\r\\n\\r\\n                  Visit us ONLINE at\\r\\n               crackerbarrel-listens.com\\r\\n                    or by PHONE at\\r\\n                    (800) 651-8284\\r\\n\\r\\n                  Enter your ACCESS \\r\\n          CODE =     90155551100137\\r\\n            (Access Code Expires in 7 Days)\\r\\n                **************************\\r\\n\\r\\n                     Cracker Barrel\\r\\n                             CB0155\\r\\n                        Lebanon TN          \\r\\n\\r\\nDine-In                    \\r\\n                           \\r\\n-------------------------------------------------------\\r\\n  Table Number:       Terminal: CB015511   Guest:      \\r\\n                  3/17/2022    01:38 AM \\r\\n-------------------------------------------------------\\r\\n  Server......:                                        \\r\\n  Cashier.....: 100100                                 \\r\\n  Customer No.:                         \\r\\n  Cust. Name..:                                      \\r\\n               <B: OT-00000000416>\\r\\n                                                       \\r\\n    ITEM NAME                 QTY      PRICE      TOTAL\\r\\n-------------------------------------------------------\\r\\n    Sunrise Sampler             1      10.99      10.99\\r\\n    Country Morning Brkfst      1       8.19       8.19    \\r                   \\r\\n    Restaurant 19.18\\r\\n                    \\r\\n    ---------------------------------------------------\\r\\n    Subtotal                                    $ 19.18\\r\\n    Shipping Charges                                   \\r\\n    State & Local Tax                            $ 1.87\\r\\n    Tip                                                \\r\\n    Total                                       $ 21.05\\r\\n    ONLINEPAYMETHOD                             $ 21.05\\r\\n\\r\\n                       Thank You\\r\\n                    Please Come Back\\r\\n                  www.CrackerBarrel.com\\r\\n                 =======================\\r\\n\\r\\n           (Mobile Checkout)\\r\\n\\r\\n<B: 01551007610000137>\\r\\n\",\"PaymentLines\":[{\"Amount\":21.05,\"Description\":\"ONLINEPAYMETHOD\"}],\"ReceiptNumber\":\"01551007610000137\",\"TransactionDateLocal\":\"2022-03-17T01:38:32.1270340\",\"TransactionDateUTC\":\"2022-03-17T06:38:32.1270340Z\"}");

var constructError = function constructError(code, customError) {
  if (customError) return {
    response: {
      data: {
        results: {
          code: code,
          message: customError
        }
      }
    }
  };
  return {
    response: {
      data: {
        results: {
          code: code,
          message: undefined
        }
      }
    }
  };
};

var setGratuity = function setGratuity(gratuity) {
  return function (dispatch, getState) {
    return dispatch(setGratuityOpearation(gratuity));
  };
};

var setReceiptCode = function setReceiptCode(receiptCode1, receiptCode2) {
  return function (dispatch, getState) {
    return dispatch(setReceiptCodeOperation(receiptCode1, receiptCode2));
  };
};

var setIsLoading = function setIsLoading(isLoading) {
  return function (dispatch, getState) {
    return dispatch(setIsLoadingOperation(isLoading));
  };
};

var reset = function reset() {
  return function (dispatch, getState) {
    return dispatch(clearOrderOpearation());
  };
};

var fetchLocationByStore = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, storeNumber) {
    var settings, apiResponse, responseObj;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // if(useMock) return { storeExist : true, featureEnabled : true}
            settings = {
              storeExist: false,
              featureEnabled: true
            };
            _context.prev = 1;
            _context.next = 4;
            return dispatch(setLocationIsLoadingOperation(true));

          case 4:
            _context.next = 6;
            return fetch(apiUtil.API.location.getLocationByStoreNumber + "?storenumber=".concat(storeNumber), {
              method: 'GET'
            });

          case 6:
            apiResponse = _context.sent;
            settings.storeExist = apiResponse.ok;
            _context.next = 10;
            return apiResponse.json();

          case 10:
            responseObj = _context.sent;
            _context.next = 13;
            return dispatch(receiveLocationOperation(responseObj));

          case 13:
            if (!useMock) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", {
              storeExist: true,
              featureEnabled: true
            });

          case 15:
            if ((responseObj === null || responseObj === void 0 ? void 0 : responseObj.MobilePay) === false) settings.featureEnabled = false;
            _context.next = 18;
            return dispatch(setLocationIsLoadingOperation(false));

          case 18:
            _context.next = 25;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](1);
            console.error(_context.t0);
            _context.next = 25;
            return dispatch(setLocationIsLoadingOperation(false));

          case 25:
            return _context.abrupt("return", settings);

          case 26:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 20]]);
  }));

  return function fetchLocationByStore(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var fetchCheckDetails = function fetchCheckDetails(releaseMobilePayRewardRedemptionFlag) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _state$mobilepay;

      var state, isMobilePayEnabled, apiResponse, _state$mobilepay2, _state$mobilepay2$cod, _state$mobilepay2$cod2, apiUrl, responseObj, _responseObj, _state$mobilepay3, _state$mobilepay3$cod, _state$mobilepay3$cod2, payload, _apiUrl, _responseObj2, _responseObj2$Detaile, _responseObj2$Detaile2, _responseObj2$Detaile3;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();
              _context2.next = 3;
              return dispatch(setIsLoadingOperation(true));

            case 3:
              _context2.next = 5;
              return fetchLocationByStore(dispatch, (_state$mobilepay = state.mobilepay) === null || _state$mobilepay === void 0 ? void 0 : _state$mobilepay.code1);

            case 5:
              isMobilePayEnabled = _context2.sent;

              if (!(!isMobilePayEnabled.featureEnabled && isMobilePayEnabled.storeExist)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 9;
              return dispatch(setIsLoadingOperation(false));

            case 9:
              _context2.next = 11;
              return dispatch(clearOrderOpearation());

            case 11:
              _context2.next = 13;
              return dispatch(receiveError(buildError(constructError("mobilepay-disabled"))));

            case 13:
              return _context2.abrupt("return");

            case 14:
              if (isMobilePayEnabled.storeExist) {
                _context2.next = 22;
                break;
              }

              _context2.next = 17;
              return dispatch(setIsLoadingOperation(false));

            case 17:
              _context2.next = 19;
              return dispatch(clearOrderOpearation());

            case 19:
              _context2.next = 21;
              return dispatch(receiveError(buildError(constructError("mobilepay-disabled", "We can’t find a store with this code. Please check your code and try again."))));

            case 21:
              return _context2.abrupt("return");

            case 22:
              if (!useMock) {
                _context2.next = 27;
                break;
              }

              _context2.next = 25;
              return dispatch(receiveCheckDetailOperation(mockCheck));

            case 25:
              _context2.next = 27;
              return dispatch(receiveOriginalCheckDetail(mockCheck));

            case 27:
              if (useMock) {
                _context2.next = 96;
                break;
              }

              _context2.prev = 28;

              if (!releaseMobilePayRewardRedemptionFlag) {
                _context2.next = 53;
                break;
              }

              apiUrl = UTIL.apiUtil.generateUrl('mobilepay', 'OrderQuery', 'v2').replace('{storeId}', "CB".concat((_state$mobilepay2 = state.mobilepay) === null || _state$mobilepay2 === void 0 ? void 0 : (_state$mobilepay2$cod = _state$mobilepay2.code1) === null || _state$mobilepay2$cod === void 0 ? void 0 : (_state$mobilepay2$cod2 = _state$mobilepay2$cod.toString()) === null || _state$mobilepay2$cod2 === void 0 ? void 0 : _state$mobilepay2$cod2.padStart(4, '0'))).replace('{checkId}', state.mobilepay.code2);
              _context2.next = 33;
              return fetch(apiUrl, {
                method: 'GET',
                headers: UTIL.apiUtil.setHeaders()
              });

            case 33:
              apiResponse = _context2.sent;

              if (!apiResponse.ok) {
                _context2.next = 46;
                break;
              }

              _context2.next = 37;
              return apiResponse.json();

            case 37:
              responseObj = _context2.sent;
              _context2.next = 40;
              return dispatch(receiveCheckDetailOperation(responseObj));

            case 40:
              _context2.next = 42;
              return dispatch(receiveOriginalCheckDetail(responseObj));

            case 42:
              _context2.next = 44;
              return dispatch(resetRewardsRedemptionAction());

            case 44:
              _context2.next = 51;
              break;

            case 46:
              _context2.next = 48;
              return apiResponse.json();

            case 48:
              _responseObj = _context2.sent;
              _context2.next = 51;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic", _responseObj.Detail || undefined))));

            case 51:
              _context2.next = 90;
              break;

            case 53:
              // TODO: remove this block after the release of the new mobile pay endpoint
              payload = {
                Store: "CB".concat((_state$mobilepay3 = state.mobilepay) === null || _state$mobilepay3 === void 0 ? void 0 : (_state$mobilepay3$cod = _state$mobilepay3.code1) === null || _state$mobilepay3$cod === void 0 ? void 0 : (_state$mobilepay3$cod2 = _state$mobilepay3$cod.toString()) === null || _state$mobilepay3$cod2 === void 0 ? void 0 : _state$mobilepay3$cod2.padStart(4, '0')),
                OrderCode: state.mobilepay.code2
              };
              _apiUrl = apiUtil.API.mobilepay.getOrder;
              _context2.next = 57;
              return fetch(_apiUrl, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-ApiKey': '026b7ad5-5ec2-4578-8c62-5815ee9b2ebb'
                },
                body: JSON.stringify(payload)
              });

            case 57:
              apiResponse = _context2.sent;

              if (!apiResponse.ok) {
                _context2.next = 90;
                break;
              }

              _context2.next = 61;
              return apiResponse.json();

            case 61:
              _responseObj2 = _context2.sent;

              if (!_responseObj2.Success) {
                _context2.next = 71;
                break;
              }

              _context2.next = 65;
              return dispatch(receiveCheckDetailOperation(_responseObj2));

            case 65:
              _context2.next = 67;
              return dispatch(receiveOriginalCheckDetail(_responseObj2));

            case 67:
              _context2.next = 69;
              return dispatch(resetRewardsRedemptionAction());

            case 69:
              _context2.next = 90;
              break;

            case 71:
              if (!((_responseObj2$Detaile = _responseObj2.DetailedErrorMessage) === null || _responseObj2$Detaile === void 0 ? void 0 : _responseObj2$Detaile.includes("Validate request timed out"))) {
                _context2.next = 76;
                break;
              }

              _context2.next = 74;
              return dispatch(receiveError(buildError(constructError("mobilepay-ls-timeout"))));

            case 74:
              _context2.next = 90;
              break;

            case 76:
              if (!((_responseObj2$Detaile2 = _responseObj2.DetailedErrorMessage) === null || _responseObj2$Detaile2 === void 0 ? void 0 : _responseObj2$Detaile2.includes("UserFacingException"))) {
                _context2.next = 88;
                break;
              }

              if (!((_responseObj2$Detaile3 = _responseObj2.DetailedErrorMessage) === null || _responseObj2$Detaile3 === void 0 ? void 0 : _responseObj2$Detaile3.includes("Order not found"))) {
                _context2.next = 84;
                break;
              }

              _context2.next = 80;
              return dispatch(receiveError(buildError(constructError("mobilepay-ls-notfound", "Hmmm, we can’t find a receipt with that code. Please try again.'"))));

            case 80:
              _context2.next = 82;
              return dispatch(clearOrderOpearation());

            case 82:
              _context2.next = 86;
              break;

            case 84:
              _context2.next = 86;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic", _responseObj2.ErrorMessage))));

            case 86:
              _context2.next = 90;
              break;

            case 88:
              _context2.next = 90;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic"))));

            case 90:
              _context2.next = 96;
              break;

            case 92:
              _context2.prev = 92;
              _context2.t0 = _context2["catch"](28);
              _context2.next = 96;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic"))));

            case 96:
              _context2.next = 98;
              return dispatch(setIsLoadingOperation(false));

            case 98:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[28, 92]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var setPayOrderPayload = function setPayOrderPayload(payload) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var state;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState();
              payload.Gratuity = state.mobilepay.Gratuity;
              _context3.next = 4;
              return dispatch(setPayOrderPayloadOperation(payload));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};

var showMobilePayWPError = function showMobilePayWPError(errorNumber) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(receiveError(buildError(constructError("mobilepay-wp-".concat(errorNumber)))));

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};

var payForOrder = function payForOrder(payload, releaseMobilePayRewardRedemptionFlag) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch, getState) {
      var _jsonObj$Payments;

      var state, jsonObj, _jsonObj$Payments2, expirationDate, month, year, today, someday, getPaymentType, paymentMethod, apiResponse, _state$mobilepay4, _state$mobilepay4$cod, _state$mobilepay4$cod2, apiUrl, responseObj, _responseObj3, detail, _state$loyalty, _state$loyalty$accoun, _state$account, _state$account$aadRes, _state$account$aadRes2, _state$account$aadRes3, _state$account2, _state$account2$aadRe, _state$account2$aadRe2, _state$account2$aadRe3, loyaltyId, loyaltyEmail, _apiUrl2, _responseObj4, _responseObj4$Detaile, _responseObj4$Detaile2;

      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              state = getState(); // if(state.mobilepay?.payload === undefined && payload ){
              //   await dispatch(receiveError(buildError(constructError("mobilepay-ls-nopayment"))))
              //   await dispatch(setIsLoadingOperation(false));
              //   return
              // }

              jsonObj = _objectSpread(_objectSpread({}, payload), {}, {
                Gratuity: state.mobilepay.Gratuity
              });

              if (!((jsonObj === null || jsonObj === void 0 ? void 0 : (_jsonObj$Payments = jsonObj.Payments) === null || _jsonObj$Payments === void 0 ? void 0 : _jsonObj$Payments.length) > 0)) {
                _context5.next = 23;
                break;
              }

              jsonObj === null || jsonObj === void 0 ? void 0 : (_jsonObj$Payments2 = jsonObj.Payments) === null || _jsonObj$Payments2 === void 0 ? void 0 : _jsonObj$Payments2.map(function (payment) {
                return payment.PaymentAmount = (payment.PaymentAmount + jsonObj.Gratuity).toFixed(2);
              }); // REVISIT ON SPLIT PAYMENT

              if (!((jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.Payments[0].TokenType) != 'GIFT' && (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.Payments[0].IsGooglePay) != true && (jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.Payments[0].IsApplePay) != true)) {
                _context5.next = 19;
                break;
              }

              // REVISIT ON SPLIT PAYMENT
              expirationDate = jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.Payments[0].ExpiryDate;

              if (!(expirationDate.length !== 4)) {
                _context5.next = 10;
                break;
              }

              _context5.next = 9;
              return dispatch(receiveError(buildError(constructError("mobilepay-wp-invalidExp"))));

            case 9:
              return _context5.abrupt("return");

            case 10:
              month = expirationDate.substring(0, 2);
              year = expirationDate.substring(2);
              today = new Date();
              someday = new Date();
              someday.setFullYear(20 + year, month);

              if (!(someday <= today)) {
                _context5.next = 19;
                break;
              }

              _context5.next = 18;
              return dispatch(receiveError(buildError(constructError("mobilepay-wp-invalidExp"))));

            case 18:
              return _context5.abrupt("return");

            case 19:
              getPaymentType = function getPaymentType(payment) {
                if (payment.IsApplePay) return 'Apple Pay';
                if (payment.IsGooglePay) return 'Google Pay';
                if (payment.TokenType == "GIFT") return 'Gift Card';
                return 'Credit Card';
              }; // TODO :: multi payment support will need to loop thru


              paymentMethod = getPaymentType(jsonObj.Payments[0]);
              _context5.next = 23;
              return dispatch(setPaymentMethodOperation(paymentMethod));

            case 23:
              if (!useMock) {
                _context5.next = 26;
                break;
              }

              _context5.next = 26;
              return dispatch(payOrderSuccessOperation(mockRecipt));

            case 26:
              if (useMock) {
                _context5.next = 92;
                break;
              }

              _context5.prev = 27;
              _context5.next = 30;
              return dispatch(setIsLoadingOperation(true));

            case 30:
              if (!releaseMobilePayRewardRedemptionFlag) {
                _context5.next = 54;
                break;
              }

              apiUrl = UTIL.apiUtil.generateUrl('mobilepay', 'PayOrder', 'v2').replace('{storeId}', "CB".concat((_state$mobilepay4 = state.mobilepay) === null || _state$mobilepay4 === void 0 ? void 0 : (_state$mobilepay4$cod = _state$mobilepay4.code1) === null || _state$mobilepay4$cod === void 0 ? void 0 : (_state$mobilepay4$cod2 = _state$mobilepay4$cod.toString()) === null || _state$mobilepay4$cod2 === void 0 ? void 0 : _state$mobilepay4$cod2.padStart(4, '0'))).replace('{checkId}', state.mobilepay.code2);
              _context5.next = 34;
              return fetch(apiUrl, {
                method: 'POST',
                headers: UTIL.apiUtil.setHeaders(),
                body: JSON.stringify(jsonObj)
              });

            case 34:
              apiResponse = _context5.sent;

              if (!apiResponse.ok) {
                _context5.next = 45;
                break;
              }

              _context5.next = 38;
              return apiResponse.json();

            case 38:
              responseObj = _context5.sent;
              _context5.next = 41;
              return dispatch(payOrderSuccessOperation(responseObj));

            case 41:
              _context5.next = 43;
              return dispatch(resetRewardsRedemptionAction());

            case 43:
              _context5.next = 52;
              break;

            case 45:
              _context5.next = 47;
              return apiResponse.json();

            case 47:
              _responseObj3 = _context5.sent;
              detail = _responseObj3.Detail || 'Something went wrong. Please try again.';

              if (detail.includes("Invalid Amount") && payload.OrderTotal === 0) {
                //TODO: this text should be content managed
                detail = 'Wow, you saved up enough rewards for everything on your order! \n' + 'Unfortunately at this time, we cannot process a full redemption using our Mobile Pay feature. Please checkout with a cashier.';
              }

              _context5.next = 52;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic", detail || undefined))));

            case 52:
              _context5.next = 86;
              break;

            case 54:
              // TODO: remove this block after the release of the new mobile pay endpoint
              loyaltyId = (_state$loyalty = state.loyalty) === null || _state$loyalty === void 0 ? void 0 : (_state$loyalty$accoun = _state$loyalty.account) === null || _state$loyalty$accoun === void 0 ? void 0 : _state$loyalty$accoun.ExternalCustomerId;
              loyaltyEmail = ((_state$account = state.account) === null || _state$account === void 0 ? void 0 : (_state$account$aadRes = _state$account.aadResponse) === null || _state$account$aadRes === void 0 ? void 0 : (_state$account$aadRes2 = _state$account$aadRes.account) === null || _state$account$aadRes2 === void 0 ? void 0 : (_state$account$aadRes3 = _state$account$aadRes2.idToken) === null || _state$account$aadRes3 === void 0 ? void 0 : _state$account$aadRes3.email) || ((_state$account2 = state.account) === null || _state$account2 === void 0 ? void 0 : (_state$account2$aadRe = _state$account2.aadResponse) === null || _state$account2$aadRe === void 0 ? void 0 : (_state$account2$aadRe2 = _state$account2$aadRe.account) === null || _state$account2$aadRe2 === void 0 ? void 0 : (_state$account2$aadRe3 = _state$account2$aadRe2.idToken) === null || _state$account2$aadRe3 === void 0 ? void 0 : _state$account2$aadRe3.signInName);

              if (loyaltyId && loyaltyEmail) {
                jsonObj.Loyalty = {
                  Id: loyaltyId,
                  Email: loyaltyEmail,
                  Channel: 'web'
                };
              }

              _apiUrl2 = apiUtil.API.mobilepay.payOrder;
              _context5.next = 60;
              return fetch(_apiUrl2, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-ApiKey': '026b7ad5-5ec2-4578-8c62-5815ee9b2ebb'
                },
                body: JSON.stringify(jsonObj) // jsonObj

              });

            case 60:
              apiResponse = _context5.sent;

              if (!apiResponse.ok) {
                _context5.next = 86;
                break;
              }

              _context5.next = 64;
              return apiResponse.json();

            case 64:
              _responseObj4 = _context5.sent;

              if (!_responseObj4.Success) {
                _context5.next = 72;
                break;
              }

              _context5.next = 68;
              return dispatch(payOrderSuccessOperation(_responseObj4));

            case 68:
              _context5.next = 70;
              return dispatch(resetRewardsRedemptionAction());

            case 70:
              _context5.next = 86;
              break;

            case 72:
              if (!((_responseObj4$Detaile = _responseObj4.DetailedErrorMessage) === null || _responseObj4$Detaile === void 0 ? void 0 : _responseObj4$Detaile.includes("Validate request timed out"))) {
                _context5.next = 77;
                break;
              }

              _context5.next = 75;
              return dispatch(receiveError(buildError(constructError("mobilepay-ls-timeout"))));

            case 75:
              _context5.next = 86;
              break;

            case 77:
              if (!((_responseObj4$Detaile2 = _responseObj4.DetailedErrorMessage) === null || _responseObj4$Detaile2 === void 0 ? void 0 : _responseObj4$Detaile2.includes("Order not found"))) {
                _context5.next = 84;
                break;
              }

              _context5.next = 80;
              return dispatch(receiveError(buildError(constructError("mobilepay-ls-notfound", "Hmmm, we can’t find a receipt with that code. Please try again.'"))));

            case 80:
              _context5.next = 82;
              return dispatch(clearOrderOpearation());

            case 82:
              _context5.next = 86;
              break;

            case 84:
              _context5.next = 86;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic", _responseObj4.ErrorMessage))));

            case 86:
              _context5.next = 92;
              break;

            case 88:
              _context5.prev = 88;
              _context5.t0 = _context5["catch"](27);
              _context5.next = 92;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic"))));

            case 92:
              _context5.next = 94;
              return dispatch(setIsLoadingOperation(false));

            case 94:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[27, 88]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }();
};

var orderValidate = function orderValidate(state) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var rewards, mobilepay, loyalty, account, _loyalty$account, _account$aadResponse, _account$aadResponse$, _account$aadResponse$2, _account$aadResponse2, _account$aadResponse3, _account$aadResponse4, _rewards$redeemedRewa, _rewards$redeemedRewa2, _rewards$redeemedRewa3, _rewards$redeemedRewa6, _rewards$redeemedRewa7, _rewards$redeemedRewa8, _mobilepay$check, _mobilepay$check2, loyaltyId, loyaltyEmail, rewardsAux, couponsAux, _rewards$redeemedRewa4, _rewards$redeemedRewa5, _rewards$redeemedRewa9, _rewards$redeemedRewa10, payload, _state$mobilepay5, _state$mobilepay5$cod, _state$mobilepay5$cod2, apiUrl, apiResponse, _rewards$redeemedRewa13, _rewards$redeemedRewa14, responseObj, _responseObj5;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              rewards = state.rewards, mobilepay = state.mobilepay, loyalty = state.loyalty, account = state.account;

              if (mobilepay === null || mobilepay === void 0 ? void 0 : mobilepay.check) {
                _context6.next = 3;
                break;
              }

              return _context6.abrupt("return", false);

            case 3:
              _context6.prev = 3;
              loyaltyId = loyalty === null || loyalty === void 0 ? void 0 : (_loyalty$account = loyalty.account) === null || _loyalty$account === void 0 ? void 0 : _loyalty$account.ExternalCustomerId;
              loyaltyEmail = (account === null || account === void 0 ? void 0 : (_account$aadResponse = account.aadResponse) === null || _account$aadResponse === void 0 ? void 0 : (_account$aadResponse$ = _account$aadResponse.account) === null || _account$aadResponse$ === void 0 ? void 0 : (_account$aadResponse$2 = _account$aadResponse$.idToken) === null || _account$aadResponse$2 === void 0 ? void 0 : _account$aadResponse$2.email) || (account === null || account === void 0 ? void 0 : (_account$aadResponse2 = account.aadResponse) === null || _account$aadResponse2 === void 0 ? void 0 : (_account$aadResponse3 = _account$aadResponse2.account) === null || _account$aadResponse3 === void 0 ? void 0 : (_account$aadResponse4 = _account$aadResponse3.idToken) === null || _account$aadResponse4 === void 0 ? void 0 : _account$aadResponse4.signInName);
              rewardsAux = [];
              couponsAux = [];

              if ((rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa = rewards.redeemedRewards) === null || _rewards$redeemedRewa === void 0 ? void 0 : (_rewards$redeemedRewa2 = _rewards$redeemedRewa.mobilePayCheckout) === null || _rewards$redeemedRewa2 === void 0 ? void 0 : (_rewards$redeemedRewa3 = _rewards$redeemedRewa2.Rewards) === null || _rewards$redeemedRewa3 === void 0 ? void 0 : _rewards$redeemedRewa3.length) > 0) {
                rewardsAux = rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa4 = rewards.redeemedRewards) === null || _rewards$redeemedRewa4 === void 0 ? void 0 : (_rewards$redeemedRewa5 = _rewards$redeemedRewa4.mobilePayCheckout) === null || _rewards$redeemedRewa5 === void 0 ? void 0 : _rewards$redeemedRewa5.Rewards;
              }

              if ((rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa6 = rewards.redeemedRewards) === null || _rewards$redeemedRewa6 === void 0 ? void 0 : (_rewards$redeemedRewa7 = _rewards$redeemedRewa6.mobilePayCheckout) === null || _rewards$redeemedRewa7 === void 0 ? void 0 : (_rewards$redeemedRewa8 = _rewards$redeemedRewa7.Coupons) === null || _rewards$redeemedRewa8 === void 0 ? void 0 : _rewards$redeemedRewa8.length) > 0) {
                couponsAux = rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa9 = rewards.redeemedRewards) === null || _rewards$redeemedRewa9 === void 0 ? void 0 : (_rewards$redeemedRewa10 = _rewards$redeemedRewa9.mobilePayCheckout) === null || _rewards$redeemedRewa10 === void 0 ? void 0 : _rewards$redeemedRewa10.Coupons;
              }

              payload = {
                'Store': mobilepay === null || mobilepay === void 0 ? void 0 : (_mobilepay$check = mobilepay.check) === null || _mobilepay$check === void 0 ? void 0 : _mobilepay$check.Store,
                'OrderCode': mobilepay === null || mobilepay === void 0 ? void 0 : (_mobilepay$check2 = mobilepay.check) === null || _mobilepay$check2 === void 0 ? void 0 : _mobilepay$check2.OrderCode,
                'LoyaltyWithRewards': {
                  'Id': loyaltyId,
                  'Email': loyaltyEmail,
                  'Coupons': couponsAux || [],
                  'Rewards': rewardsAux || []
                }
              }; // storybook mock

              if (!(window.location.href.indexOf('localhost:9009') > -1)) {
                _context6.next = 15;
                break;
              }

              return _context6.abrupt("return", new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve({});
                }, 2000);
              }).then(function () {
                var _rewards$redeemedRewa11, _rewards$redeemedRewa12;

                dispatch(receiveCheckDetailOperation(_objectSpread(_objectSpread({}, OrderValidationResponse), {}, {
                  RedeemedRewards: (rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa11 = rewards.redeemedRewards) === null || _rewards$redeemedRewa11 === void 0 ? void 0 : _rewards$redeemedRewa11.totalDiscountAmount) ? parseFloat(rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa12 = rewards.redeemedRewards) === null || _rewards$redeemedRewa12 === void 0 ? void 0 : _rewards$redeemedRewa12.totalDiscountAmount) : 0
                })));
              }));

            case 15:
              apiUrl = UTIL.apiUtil.generateUrl('mobilepay', 'OrderValidate', 'v2').replace('{storeId}', "CB".concat((_state$mobilepay5 = state.mobilepay) === null || _state$mobilepay5 === void 0 ? void 0 : (_state$mobilepay5$cod = _state$mobilepay5.code1) === null || _state$mobilepay5$cod === void 0 ? void 0 : (_state$mobilepay5$cod2 = _state$mobilepay5$cod.toString()) === null || _state$mobilepay5$cod2 === void 0 ? void 0 : _state$mobilepay5$cod2.padStart(4, '0'))).replace('{checkId}', state.mobilepay.code2);

              if (payload.LoyaltyWithRewards.Rewards.length === 0 || payload.LoyaltyWithRewards.Coupons.length === 0) {
                apiUrl += '?clear=true';
              }

              _context6.next = 19;
              return fetch(apiUrl, {
                method: 'POST',
                headers: UTIL.apiUtil.setHeaders(),
                body: JSON.stringify(payload)
              });

            case 19:
              apiResponse = _context6.sent;

              if (!apiResponse.ok) {
                _context6.next = 28;
                break;
              }

              _context6.next = 23;
              return apiResponse.json();

            case 23:
              responseObj = _context6.sent;
              _context6.next = 26;
              return dispatch(receiveCheckDetailOperation(_objectSpread(_objectSpread({}, responseObj), {}, {
                RedeemedRewards: (rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa13 = rewards.redeemedRewards) === null || _rewards$redeemedRewa13 === void 0 ? void 0 : _rewards$redeemedRewa13.totalDiscountAmount) ? parseFloat(rewards === null || rewards === void 0 ? void 0 : (_rewards$redeemedRewa14 = rewards.redeemedRewards) === null || _rewards$redeemedRewa14 === void 0 ? void 0 : _rewards$redeemedRewa14.totalDiscountAmount) : 0
              })));

            case 26:
              _context6.next = 33;
              break;

            case 28:
              _context6.next = 30;
              return apiResponse.json();

            case 30:
              _responseObj5 = _context6.sent;
              _context6.next = 33;
              return dispatch(receiveError(buildError(constructError("mobilepay-generic", _responseObj5.Detail || undefined))));

            case 33:
              _context6.next = 38;
              break;

            case 35:
              _context6.prev = 35;
              _context6.t0 = _context6["catch"](3);
              console.log('Error trying to validate the order', _context6.t0.message);

            case 38:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[3, 35]]);
    }));

    return function (_x11) {
      return _ref6.apply(this, arguments);
    };
  }();
};

var handleOrderValidate = function handleOrderValidate(orderNumber) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch, getState) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", dispatch(orderValidate(getState())));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x12, _x13) {
      return _ref7.apply(this, arguments);
    };
  }();
};

export default {
  setReceiptCode: setReceiptCode,
  payForOrder: payForOrder,
  fetchCheckDetails: fetchCheckDetails,
  fetchLocationByStore: fetchLocationByStore,
  setPayOrderPayload: setPayOrderPayload,
  setGratuity: setGratuity,
  showMobilePayWPError: showMobilePayWPError,
  setIsLoading: setIsLoading,
  reset: reset,
  handleOrderValidate: handleOrderValidate,
  resetCheck: resetCheck
};